export const checkIsUserCountourA = (countourType?: number) => (
  countourType !== 1
);

export const checkIsUserCountourB = (countourType?: number) => (
  countourType === 1
);
